import React from 'react';
import { toast, ToastOptions } from 'react-toastify';

import Alert from '../Alert';

const admanToast = {
  ...toast,
  success: (content: string, options?: ToastOptions<{}> | undefined): number | string => {
    return toast.success(<Alert type={'success'} text={content} />, options);
  },
  error: (content: string, options?: ToastOptions<{}> | undefined): number | string => {
    return toast.error(<Alert type={'error'} text={content} />, options);
  },
  warning: (content: string, options?: ToastOptions<{}> | undefined): number | string => {
    return toast.warning(<Alert type={'warning'} text={content} />, options);
  },
  info: (content: string, options?: ToastOptions<{}> | undefined): number | string => {
    return toast.info(<Alert type={'info'} text={content} />, options);
  },
};

export default admanToast;
